import { wrapFunctionalComponent } from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import dateUtils from 'utils/Date';
import {
    Box, Text, Flex, Link
} from 'components/ui';
import Chevron from 'components/Chevron/Chevron';
import { colors } from 'style/config';
import PointActivityDetail from 'components/Content/BeautyInsider/BeautyInsiderModules/PointsActivityDetail/PointActivityDetail.f';
import EN from './locales/PointsActivityCard_en_US';
import FR from './locales/PointsActivityCard_fr_CA';
import anaUtils from 'analytics/utils';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(EN, FR);
const ENTER = 'Enter';
const SPACE = ' ';

const styles = {
    points: isPlus => `
        font-weight: bold;
        ${!isPlus ? `color: ${colors.gray}` : ''};
        margin-right: 10px;
        margin-left: auto;
    `,
    componentsWrap: `
        border-bottom: 1px solid ${colors.lightGray};
        margin-bottom: 16px;
        padding-bottom: 16px;
        &:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }
    `,
    link: `
        color: ${colors.blue};
        text-decoration: underline;
    `,
    biStatusUpdatecontainer: `
        background-color: ${colors.nearWhite};
        padding: 8px;
        margin-top: 12px;
    `
};

const PointsActivityCard = ({ record, isExpanded, onToggle }) => {
    const isPlus = record.netGroupPoints > 0;
    const points = `${isPlus ? '+' : ''}${record.netGroupPoints} pts`;
    const handleToggleKeyDown = event => {
        if (event.key === ENTER || event.key === SPACE) {
            event.preventDefault();
            onToggle();
        }
    };

    const goToOrder = () => {
        anaUtils.setNextPageData({
            linkData: 'points activity:view order detail',
            prop55: 'points activity:view order detail',
            pageName: digitalData?.page?.attributes?.sephoraPageInfo?.pageName
        });
    };

    return (
        <Box css={styles.componentsWrap}>
            <Box
                onClick={onToggle}
                onKeyDown={handleToggleKeyDown}
                tabIndex={0}
                width='100%'
                cursor='pointer'
                role='button'
                aria-expanded={isExpanded}
            >
                <Flex alignItems='center'>
                    <Text fontWeight={'bold'}>{record.groupDescription}</Text>
                    {record.orderStatus && <Text css={styles.points(false)}>{record.orderStatus}</Text>}
                    {!record.orderStatus && <Text css={styles.points(isPlus)}>{points}</Text>}
                    <Chevron
                        direction={isExpanded ? 'up' : 'down'}
                        size='10px'
                        aria-hidden={true}
                    />
                </Flex>
                <Text color={colors.gray}>{dateUtils.formatDateMDY(record.groupDate, true)}</Text>
            </Box>
            {isExpanded && (
                <Box marginTop={4}>
                    {record.digitalOrderId && (
                        <Text is='p'>
                            {`${getText('orderNumber')}: `}
                            {record.displayDigitalOrderIdAsLink ? (
                                <Link
                                    css={styles.link}
                                    href={`/profile/orderdetail/${record.digitalOrderId}`}
                                    onClick={goToOrder}
                                >
                                    {record.digitalOrderId}
                                </Link>
                            ) : (
                                record.digitalOrderId
                            )}
                        </Text>
                    )}
                    {record.pointActivities?.map((activity, index) => (
                        <PointActivityDetail
                            key={activity.activityId || index}
                            activity={activity}
                        />
                    ))}
                    {record.tierChangeMessage && (
                        <Box css={styles.biStatusUpdatecontainer}>
                            <Text
                                is='p'
                                children={record.tierChangeMessage}
                            />
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default wrapFunctionalComponent(PointsActivityCard, 'PointsActivityCard');
